import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {font, colors} from 'theme';

export const ContentWrapper = styled.div`
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
    font-family: ${font.family.primary};
    font-size: 12px;
`;

export const Text = styled.p`
    text-align: center;
    line-height: 20px;
`;

export const CodeImage = styled.img`
    margin-top: 10px;
    margin-bottom: 20px;
    -webkit-user-drag: none;
    width: 100%;
    height: auto;
`;

export const CancelButton = styled(Button)`
    width: 120px;
`;

export const CheckResult = styled.div<{original: boolean}>`
    width: 370px;
    max-width: 100%;
    padding: 12px;
    color: ${colors.white};
    background-color: ${(p) => (p.original ? '#65C686' : '#F96969')};
    text-align: center;
    border-radius: 4px;
    margin-bottom: 30px;
`;
